module.exports = __webpack_public_path__ + "static/img/Thomas-Deng.51b4ca4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Thomas-Deng.jpg
// module id = 22h+
// module chunks = 0